import { useTranslation } from 'react-i18next';

import { Badge } from '@/components/ui/badge';
import { ChooseLogo } from '@/components/ui/choose-logo';
import {
  ActorRole,
  DealState,
  type GetDealsListQuery,
} from '@/lib/graphql/generated/graphql';
import { Check, FileSpreadsheet, Sparkles } from 'lucide-react';

export type DealListRow = GetDealsListQuery['listDeals']['items'][number];

export function getDealListStatus(
  deal: Pick<DealListRow, 'state' | 'editionMode' | 'isOfferControlFlow'>
) {
  if (deal.state === DealState.Empty) return 'notStarted';
  if (deal.state === DealState.NegotiationClosed) return 'closed';
  if (deal.isOfferControlFlow) return 'csv';
  return deal.editionMode === ActorRole.Brand ? 'brand' : 'platform';
}

export function DealStatusBadge({ deal }: { deal: DealListRow }) {
  const { t } = useTranslation();
  const status = getDealListStatus(deal);
  return (
    <Badge
      variant="secondary"
      className="gap-1.5 whitespace-nowrap rounded-sm font-normal"
    >
      {status === 'platform' ? (
        <ChooseLogo width={12} height={12} />
      ) : status === 'csv' ? (
        <FileSpreadsheet size={12} />
      ) : status === 'closed' ? (
        <Check size={12} />
      ) : status === 'notStarted' ? (
        <Sparkles size={12} />
      ) : null}
      {t(`deals-list.status.${status}`)}
    </Badge>
  );
}
